import React, { createContext, useState } from 'react';

export const AppContext = createContext(
    {
      isExpanded: false,
      setIsExpanded: () => {},
      isPopUp: false,
      setIsPopUp: ()=>{},
    }
);

export function AppProvider({children}) {
    const [isExpanded, setIsExpanded]     = useState(false);
    const [isPopUp, setIsPopUp]   = useState(false);

    return (
        <AppContext.Provider
          value={{
            isExpanded,
            setIsExpanded,
            isPopUp,
            setIsPopUp
          }}
        >
          {children}
        </AppContext.Provider>
      );
}